var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9525 24.9999C19.9194 24.9999 25.5672 19.4035 25.5672 12.5C25.5672 5.59642 19.9194 0 12.9525 0C5.98566 0 0.337891 5.59642 0.337891 12.5C0.337891 19.4035 5.98566 24.9999 12.9525 24.9999Z",
    fill: "url(#paint0_linear_129_31317)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5658 12.4998C25.5658 9.89068 24.7587 7.46867 23.3787 5.46476C22.4246 4.07909 21.0347 3.04025 19.4367 2.48648C18.0914 2.02022 16.6454 1.7666 15.1395 1.7666C7.95766 1.76645 2.1189 7.5522 2.11914 14.6687C2.11922 17.0684 2.78127 19.3146 3.93299 21.2392C6.22313 23.5593 9.41701 24.9999 12.951 24.9999C19.9012 25 25.5658 19.3868 25.5658 12.4998Z",
    fill: "url(#paint1_linear_129_31317)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5678 12.4997C25.5678 10.5738 25.1276 8.75009 24.3424 7.12095C24.1811 6.84313 24.0096 6.57187 23.828 6.30802C22.8738 4.92235 21.4839 3.88351 19.8859 3.32974C18.5407 2.86348 17.0946 2.60986 15.5887 2.60986C8.40687 2.60971 2.56812 8.39546 2.56836 15.5121C2.56844 17.5033 3.02543 19.3881 3.83865 21.0718C3.87087 21.1275 3.90206 21.1839 3.93507 21.239C6.22521 23.5592 9.41909 24.9998 12.953 24.9998C19.9033 24.9999 25.5679 19.3867 25.5678 12.4997Z",
    fill: "url(#paint2_linear_129_31317)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.337891 12.5C0.337891 19.4036 5.98569 25 12.9525 25C19.9194 25 25.5672 19.4035 25.5672 12.5C25.5672 12.2132 25.5565 11.9289 25.5373 11.647H0.367747C0.348526 11.9289 0.337891 12.2132 0.337891 12.5Z",
    fill: "url(#paint3_linear_129_31317)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77531 18.2739C3.72183 17.9549 3.41759 17.7388 3.0957 17.7923C2.77382 17.8453 2.55615 18.1468 2.60964 18.4657C2.74774 19.2899 2.97691 20.0891 3.29075 20.8411C3.38489 21.0667 3.605 21.203 3.837 21.203C3.91223 21.203 3.98872 21.1886 4.06254 21.1584C4.3641 21.0348 4.50739 20.6924 4.38269 20.3936C4.10311 19.7236 3.89876 19.0105 3.77531 18.2739Z",
    fill: "url(#paint4_linear_129_31317)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07611 15.4509C3.10431 15.4549 3.13236 15.4568 3.16001 15.4568C3.44944 15.4568 3.70231 15.2458 3.74422 14.9537C3.84845 14.2267 4.02443 13.4969 4.26715 12.7847C4.37153 12.4783 4.20562 12.1461 3.89642 12.0427C3.58722 11.9392 3.25202 12.1036 3.14764 12.41C2.88169 13.1903 2.68884 13.9907 2.5743 14.7889C2.52845 15.109 2.75304 15.4054 3.07611 15.4509Z",
    fill: "url(#paint5_linear_129_31317)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1003 4.71289C22.436 4.21852 21.7069 3.803 20.933 3.47772C20.6328 3.35165 20.2859 3.49029 20.1584 3.78809C20.031 4.08574 20.1712 4.42945 20.4716 4.55567C21.1573 4.84387 21.8029 5.21178 22.3905 5.64923C22.4969 5.72839 22.6215 5.76656 22.7449 5.76656C22.9244 5.76656 23.1017 5.68584 23.2178 5.53276C23.4137 5.27407 23.3611 4.9071 23.1003 4.71289Z",
    fill: "url(#paint6_linear_129_31317)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29189 7.21731C5.73202 7.81479 5.2206 8.45849 4.77196 9.13068C4.59195 9.4003 4.66655 9.76352 4.93873 9.94197C5.03901 10.0078 5.15222 10.0392 5.26416 10.0392C5.45583 10.0392 5.64379 9.94696 5.75746 9.77671C6.17065 9.15784 6.64182 8.56489 7.15781 8.01416C7.37981 7.77725 7.36602 7.40677 7.12685 7.18671C6.88768 6.96666 6.51389 6.98047 6.29189 7.21731Z",
    fill: "url(#paint7_linear_129_31317)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.274 3.70873C10.5264 4.02847 9.79689 4.41722 9.10585 4.86427C8.83257 5.04101 8.75568 5.40376 8.93404 5.67455C9.04732 5.84652 9.23646 5.94004 9.42931 5.94004C9.54007 5.94004 9.65209 5.9092 9.75175 5.84472C10.3866 5.43412 11.0564 5.07715 11.7424 4.78371C12.042 4.65554 12.18 4.31105 12.0506 4.01419C11.9213 3.71748 11.5738 3.58056 11.274 3.70873Z",
    fill: "url(#paint8_linear_129_31317)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3082 2.63565C16.4945 2.58233 15.6598 2.61192 14.8324 2.72237C14.509 2.76554 14.2821 3.0603 14.3257 3.38074C14.3656 3.67472 14.6192 3.88814 14.9104 3.88814C14.9367 3.88814 14.9634 3.88642 14.9901 3.88283C15.74 3.78284 16.4951 3.75606 17.2304 3.80399C17.5559 3.82608 17.8374 3.58097 17.8588 3.25834C17.8803 2.93564 17.6338 2.6568 17.3082 2.63565Z",
    fill: "url(#paint9_linear_129_31317)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87648 7.92792C2.58918 7.77476 2.2309 7.88124 2.07618 8.166C1.683 8.88987 1.35245 9.64168 1.09375 10.4004C0.989287 10.7067 1.15527 11.039 1.46439 11.1425C1.5271 11.1635 1.59083 11.1734 1.65354 11.1734C1.90003 11.1734 2.12999 11.0193 2.21317 10.7751C2.45077 10.0784 2.75469 9.3872 3.11667 8.72094C3.27131 8.43625 3.16378 8.08123 2.87648 7.92792Z",
    fill: "url(#paint10_linear_129_31317)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58197 14.4548C1.58197 14.3219 1.58465 14.1859 1.59001 14.0505C1.60269 13.7274 1.34871 13.4553 1.02265 13.4428C0.695334 13.4313 0.421976 13.6819 0.409292 14.005C0.403384 14.1554 0.400391 14.3067 0.400391 14.4548C0.400391 15.1417 0.46357 15.819 0.588117 16.4679C0.64208 16.7486 0.889757 16.944 1.16784 16.944C1.20447 16.944 1.24166 16.9407 1.27892 16.9337C1.59946 16.8732 1.80988 16.5668 1.74898 16.2491C1.63806 15.6721 1.58197 15.0684 1.58197 14.4548Z",
    fill: "url(#paint11_linear_129_31317)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94561 3.49596C5.57197 3.80524 5.20597 4.13685 4.85793 4.48164C4.62822 4.70935 4.40283 4.94619 4.18816 5.18576C3.97145 5.42751 3.99358 5.79753 4.23756 6.01227C4.35013 6.11133 4.49012 6.16004 4.62971 6.16004C4.7927 6.16004 4.95491 6.09361 5.07165 5.96333C5.27088 5.74101 5.48019 5.52111 5.6936 5.30972C6.01675 4.98943 6.35636 4.68164 6.70306 4.39476C6.95349 4.18751 6.98697 3.81828 6.77782 3.57012C6.56866 3.32197 6.19612 3.28863 5.94561 3.49596Z",
    fill: "url(#paint12_linear_129_31317)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3087 0.603635C10.5343 0.832432 9.76419 1.13406 9.01967 1.50025C8.7274 1.64404 8.60805 1.99539 8.75316 2.285C8.85636 2.491 9.06551 2.61028 9.28286 2.61028C9.37109 2.61028 9.46074 2.59061 9.54511 2.54908C10.2294 2.21248 10.9362 1.93552 11.6463 1.72577C11.959 1.63334 12.137 1.30736 12.0437 0.997454C11.9504 0.687707 11.6216 0.511288 11.3087 0.603635Z",
    fill: "url(#paint13_linear_129_31317)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4507 0.35775C16.6594 0.16728 15.8256 0.0687664 14.9724 0.0649414C14.9715 0.0649414 14.9706 0.0649414 14.9697 0.0649414C14.6446 0.0649414 14.3804 0.325354 14.3789 0.647748C14.3774 0.971156 14.6408 1.23446 14.9671 1.23586C15.7282 1.23922 16.47 1.32665 17.1717 1.49557C17.2186 1.50689 17.2655 1.51228 17.3116 1.51228C17.5779 1.51228 17.8197 1.33258 17.8853 1.06491C17.9623 0.750632 17.7678 0.434016 17.4507 0.35775Z",
    fill: "url(#paint14_linear_129_31317)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_129_31317",
    x1: 6.33995,
    y1: 2.2484,
    x2: 11.1611,
    y2: 9.86031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_129_31317",
    x1: 8.56078,
    y1: 5.02238,
    x2: 16.2561,
    y2: 17.8087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#B83033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_129_31317",
    x1: 12.914,
    y1: 13.1962,
    x2: -1.90348,
    y2: 6.53852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#9E2A28",
    stopOpacity: 0.169
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4456,
    stopColor: "#852820",
    stopOpacity: 0.446
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7949,
    stopColor: "#5D2414",
    stopOpacity: 0.795
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_129_31317",
    x1: 13.266,
    y1: 14.0747,
    x2: 16.1067,
    y2: 23.3006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#9E2A28",
    stopOpacity: 0.169
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4456,
    stopColor: "#852820",
    stopOpacity: 0.446
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7949,
    stopColor: "#5D2414",
    stopOpacity: 0.795
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_129_31317",
    x1: 2.6896,
    y1: 19.4935,
    x2: 3.76626,
    y2: 19.4935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_129_31317",
    x1: 2.71759,
    y1: 13.498,
    x2: 3.73982,
    y2: 13.8419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_129_31317",
    x1: 21.9595,
    y1: 4.09081,
    x2: 21.5198,
    y2: 5.05659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_129_31317",
    x1: 5.59889,
    y1: 8.25131,
    x2: 6.53828,
    y2: 8.93602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_129_31317",
    x1: 10.2456,
    y1: 4.439,
    x2: 10.8156,
    y2: 5.38036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_129_31317",
    x1: 16.0565,
    y1: 2.79208,
    x2: 16.1338,
    y2: 3.88504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_129_31317",
    x1: 1.37758,
    y1: 9.17003,
    x2: 2.55536,
    y2: 9.7247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_129_31317",
    x1: 0.407165,
    y1: 15.0417,
    x2: 1.22045,
    y2: 15.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_129_31317",
    x1: 5.14255,
    y1: 4.3886,
    x2: 5.79234,
    y2: 5.12304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_129_31317",
    x1: 10.1669,
    y1: 1.11611,
    x2: 10.5548,
    y2: 2.00347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_129_31317",
    x1: 16.1405,
    y1: 0.21841,
    x2: 16.1405,
    y2: 1.18114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall);
export default __webpack_public_path__ + "static/media/ball.f2a6d7bd92db5a72117a1ecba3b19524.svg";
export { ForwardRef as ReactComponent };